<div>
    <sag-ui-button [menuOffsetTop]="12" sag-ui-menu-trigger [menuTriggerFor]="label" color="tertiary"
        ><span class="flex items-center gap-2">{{ label }}<span class="icon-chevron-down"></span></span
    ></sag-ui-button>
    <sag-ui-menu [menu]="label">
        <div class="bg-shs-gray-5 p-2 w-72 top-0">
            <sag-ui-input [formControl]="selectControl" [floatLabel]="true" label="Search Users"></sag-ui-input>
        </div>
        <div class="overflow-auto max-h-52 h-full flex flex-col gap-2 w-72">
            @if ((users | async); as users) { @for (user of users; track $index) {
            <div
                [attr.data-selected]="selected.includes(user.value.gid)"
                (click)="select(user.value.gid)"
                class="flex-1 p-2 px-4 rounded-md hover:shadow-shs-gray-3 cursor-pointer text-shs-white-1 data-[selected=true]:text-shs-orange"
            >
                {{ user.label }}
            </div>
            } }
        </div>
    </sag-ui-menu>
</div>
